import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaStar } from "react-icons/fa";

function Testimonial() {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 1,
        //             infinite: true,
        //             dots: true,
        //         },
        //     },
        //     {
        //         breakpoint: 600,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1,
        //             initialSlide: 1,
        //         },
        //     },
        // ],
    };
    return (
        <section className='testimonial'>
            <div className="container"> {/* data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1300" */}
                <div className="d-flex align-items-center justify-content-center flex-column position-relative">
                    <div className="testimonial-hr d-flex align-items-center gap-2">
                        <hr />
                        <h6>Testimonials</h6>
                    </div>
                    <h3>What Our Client Says</h3>
                </div>
                <div className="testimonial-slider">
                    <Slider {...settings}>
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>The team’s creativity and dedication exceeded our expectations. They transformed our ideas into reality with incredible results. We couldn’t be happier with the service and professionalism.</p>
                            <h5>Emma Thompson</h5>
                            <h6>Creative Director at Inspire Media</h6>
                        </div>
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>Working with them was a game-changer for our brand. Their innovative approach and attention to detail helped boost our online presence. Highly recommended for anyone looking to make an impact.</p>
                            <h5>Michael Lee</h5>
                            <h6>CEO of NextGen Solutions</h6>
                        </div>
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>Exceptional service and fantastic results! The project was delivered on time and beyond our expectations. Their expertise and unique approach made all the difference.</p>
                            <h5>Sophia Martinez</h5>
                            <h6>Marketing Head at BrightWave Tech</h6>
                        </div>
                        <div className='testimon d-flex align-items-center flex-column text-center'>
                            <p>An outstanding experience from start to finish! Their innovative strategies and flawless execution have significantly improved our brand’s visibility. Truly a team of professionals who deliver on their promises.</p>
                            <h5>David Williams</h5>
                            <h6>Founder of Skyline Ventures</h6>
                        </div>
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default Testimonial
